import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { buildProgressPhotoPreviewHref } from "../../../../../utils/daily-stats";

function LogProgressPhotosCard({ progressPhotos, dailyStatId, utcDate }) {
  const { t } = useTranslation("athlete-portal");
  if (!progressPhotos?.bodyPhotos) return null;
  const photos = Object.entries(progressPhotos.bodyPhotos).filter(
    ([, v]) => v?.s3Path
  );
  if (photos.length === 0) return null;
  return (
    <div className="log-card log-card--progress-photos">
      <div className="log-card__header">
        <SvgIcon
          src="/img/new-icons/vuesax-linear-camera.svg"
          useCurrentColor={true}
        />
        {t("calendar.cards.photos.title")}
      </div>
      <div className="log-card__photos">
        {photos.map(([angle, photo]) => {
          const href = buildProgressPhotoPreviewHref(
            angle,
            photo.s3Path,
            photo.threadId,
            dailyStatId,
            utcDate
          );
          return (
            <a key={angle} href={href} className="log-card__photo-link">
              <img
                src={photo.s3Path}
                alt={angle}
                className="log-card__photo-thumb"
              />
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default LogProgressPhotosCard;
